
import axios from "axios";
import moment from 'moment'

export default {
  namespaced: true,
    state: {
        lista: [],
        perPage: 100,
        filtroAvancado: false,
        filtroCabecalho: false,
        dt1: moment().format('YYYY-MM-DD'),
        dt2: moment().format('YYYY-MM-DD'),
        id: null,
        clienteId: null,
        centroCustoId: null,
        departamentoId: null,
        requisitanteId: null,
        usuarioAtendimentoId: null,
        tipoData: 'C',
        tipoStatus: ['0','1','2','3','4','5','6'],
        registroSelecionadoId: null,
        paginaAtual: 1,
    },
    getters: {
      LISTA: state => {
          return state.lista
      },
      PER_PAGE: state => { 
          return state.perPage
      },
      FILTRO_AVANCADO: state => {
          return state.filtroAvancado
      },
      FILTRO_CABECALHO: state => {
          return state.filtroCabecalho
      },
      DT1: state => {
          return state.dt1
      },
      DT2: state => {
          return state.dt2
      },
      ID: state => {
          return state.id
      },
      CLIENTE_ID: state => {
          return state.clienteId
      },
      CENTRO_CUSTO_ID: state => {
          return state.centroCustoId
      },
      DEPARTAMENTO_ID: state => {
          return state.departamentoId
      },
      REQUISITANTE_ID: state => {
          return state.requisitanteId
      },
      TIPO_DATA: state => {
          return state.tipoData
      },
      TIPO_STATUS: state => {
          return state.tipoStatus
      },
      
      USUARIO_ATENDIMENTO_ID: state => {
          return state.usuarioAtendimentoId
      },
      REGISTRO_SELECIONADO_ID: state => {
          return state.registroSelecionadoId
      },
      PAGINA_ATUAL: state => {
          return state.paginaAtual
      }
    },
    /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
    mutations: {
      SET_LISTA: (state, payload) => {
          state.lista = payload
      },
      SET_PER_PAGE: (state, payload) => {
          state.perPage = payload
      },
      SET_FILTRO_AVANCADO: (state, payload) => {
          state.filtroAvancado = payload
      },
      SET_FILTRO_CABECALHO: (state, payload) => {
          state.filtroCabecalho = payload
      },
      SET_DT1: (state, payload) => {
          state.dt1 = payload
      },
      SET_DT2: (state, payload) => {
          state.dt2 = payload
      },
      SET_ID: (state, payload) => {
          state.id = payload
      },
      SET_CENTRO_CUSTO_ID: (state, payload) => {
          state.centroCustoId = payload
      },
      SET_DEPARTAMENTO_ID: (state, payload) => {
          state.departamentoId = payload
      },
      SET_REQUISITANTE_ID: (state, payload) => {
          state.requisitanteId = payload
      },
      SET_USUARIO_ATENDIMENTO_ID: (state, payload) => {
          state.usuarioAtendimentoId = payload
      },
      SET_TIPO_STATUS: (state, payload) => {
          state.tipoStatus = payload
      },
      SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
          state.registroSelecionadoId = payload
      },
      SET_PAGINA_ATUAL: (state, payload) => {
          state.paginaAtual = payload
      },
      SET_LIMPAR: (state, payload) => {
        lista = []
        dt1 = moment().format('YYYY-MM-DD')
        dt2 = moment().format('YYYY-MM-DD')
        id = null
        clienteId = null
        centroCustoId = null
        departamentoId = null
        requisitanteId = null
        usuarioAtendimentoId = null
        tipoData = 'C'
        tipoStatus = ['0','1','2','3','4','5']
        registroSelecionadoId = null
        paginaAtual = 1
      },
      SET_LIMPAR_APENAS_FILTRO: (state, payload) => {
          state.filtroAvancado = false,
          state.lista = [],
          state.dt1 = moment().format('YYYY-MM-DD'),
          state.dt2 =  moment().format('YYYY-MM-DD'),
          state.id = null,
          state.id = null
          state.clienteId = null
          state.centroCustoId = null
          state.departamentoId = null
          state.requisitanteId = null
          state.usuarioAtendimentoId = null
          state.tipoData = ''
          state.tipoStatus = ['0','1','2','3','4','5', '6']
          state.paginaAtual = 1
      }
  },
  /** ACTOINS SAO ASSINCRONOS */
  actions: {
    GET_LISTA: ({ commit, getters }) => {
        return new Promise((resolve, reject) => {
            // Monte um objeto com todos os possíveis filtros
            const filtros = {
                todos: getters.TODOS,
                id: getters.ID,
                dt1: getters.DT1,
                dt2: getters.DT2,
                descricao: getters.DESCRICAO,
                centroCustoId: getters.CENTRO_CUSTO_ID,
                departamentoId: getters.DEPARTAMENTO_ID,
                requisitanteId: getters.REQUISITANTE_ID,
                usuarioAtendimentoId: getters.USUARIO_ATENDIMENTO_ID,
                tipoData: getters.TIPO_DATA,
                tipoStatus: getters.TIPO_STATUS
                
            }

            axios
                .post('/api/protected/almoxarife/pesquisar', filtros)
                .then(({ data, status }) => {
                commit("SET_LISTA", data);
                if (status === 200 || status === 201) {
                    resolve({ data, status });
                }
                })
                .catch(error => {
                  reject(error)
                })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/almoxarife-store.js